import toPercentString from './toPercentString';
import type { LayoutPositionDetails } from '../interfaces/LayoutPositionDetails';
import { toPixelString } from 'owa-calendar-surface-core';

export default function convertAllDayLayoutPositionToStyles(
    layoutPosition: LayoutPositionDetails
): React.CSSProperties {
    return {
        ...layoutPosition,
        top: toPixelString(layoutPosition.top),
        left: toPercentString(layoutPosition.left),
        right: toPercentString(layoutPosition.right),
        height: toPixelString(layoutPosition.height),
    };
}
